module.exports = __webpack_public_path__ + "img/hj-bg3.f4ee49d7.jpg";